import { apiDelete, apiGet, apiPatch, apiPost } from './client.js';

export type DiscountPreset = {
  id: string;
  tenantId: string;
  storeId: string | null;
  name: string;
  code: string | null;
  description: string | null;
  discountType: 'percent' | 'fixed';
  value: string;
  requiresApproval: boolean;
  minRole: string | null;
  appliesTo: 'all' | 'repairs' | 'parts' | 'accessories';
  maxUsesPerTicket: number | null;
  requiresNote: boolean;
  active: boolean;
  sortOrder: number;
  createdAt: string;
};

export type DiscountPresetInput = {
  name: string;
  code?: string | null;
  description?: string | null;
  discountType: 'percent' | 'fixed';
  value: number;
  requiresApproval?: boolean;
  minRole?: string | null;
  appliesTo?: 'all' | 'repairs' | 'parts' | 'accessories';
  maxUsesPerTicket?: number | null;
  requiresNote?: boolean;
  active?: boolean;
  sortOrder?: number;
  allStores?: boolean;
  storeId?: string | null;
};

export const discountPresetsApi = {
  list(params?: { includeInactive?: boolean; appliesTo?: string }) {
    const q = new URLSearchParams();
    if (params?.includeInactive) q.set('includeInactive', 'true');
    if (params?.appliesTo) q.set('appliesTo', params.appliesTo);
    const qs = q.toString();
    return apiGet<DiscountPreset[]>(`/api/v1/discount-presets${qs ? `?${qs}` : ''}`).then(
      (r) => r.data,
    );
  },

  create(body: DiscountPresetInput) {
    return apiPost<DiscountPreset, DiscountPresetInput>('/api/v1/discount-presets', body).then(
      (r) => r.data,
    );
  },

  update(id: string, body: Partial<DiscountPresetInput>) {
    return apiPatch<DiscountPreset, Partial<DiscountPresetInput>>(
      `/api/v1/discount-presets/${id}`,
      body,
    ).then((r) => r.data);
  },

  remove(id: string) {
    return apiDelete(`/api/v1/discount-presets/${id}`);
  },
};
